import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import { useHistory } from "react-router-dom";

const ExhibitHall = (props) => {
  const history = useHistory();
  const eventId = localStorage.getItem("eventId");
  const [exhibitorsList, setExhibitorsList] = useState([]);
  const [pageLoader, setPageLoader] = useState(true);
  const logoLevelOrder = ['1', '2', '3','silver','4','5']; // Customize as needed
  const logoLevelConfig = {
    '1': { label: 'Diamond' },
    '2': { label: 'Platinum' },
    '3': { label: 'Gold'},
    silver:{label:'Silver'},
    '4': { label: 'Bronze' },
    '5': { label: 'Nickel' }
  };
  const groupedSponsors = (data) => {
    return data.reduce((acc, item) => {
      let level = String(item.logo_level); // convert to string
      if (level === '0' || level === '' || level === 'null' || level === 'undefined') {
          level = 'silver';
      }
      if (!acc[level]) {
        acc[level] = [];
      }
      acc[level].push(item);
      return acc;
    }, {});
  };

  useEffect(() => {
   // getEventInfo();
    getSponsorsLogos();
  }, []);

  const getSponsorsLogos = () => {
    /* getting sponsers logos */
    Axios.get(`${global.config.requestUrl}user/getSponsorsLogosMshc2025?eventId=${localStorage.getItem('eventId')}`,
    {headers: { "auth-token": localStorage.exhibitorToken }}
    )
      .then((res) => {
        setPageLoader(false);
        console.log("responce result",res);
        if (res.data.errorCode === 0) {
          setExhibitorsList(res.data.data);
          console.log(res.data.data)
        } else {
          setExhibitorsList([
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
            {
              logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
              exhibitor_id: null,
            },
          ]);
        }
      })
      .catch((err) => {
        setPageLoader(false);
        console.log(err);
      });
  };

  // const getEventInfo = () => {
  //   Axios.get(`${global.config.requestUrl}getEventInfo?eventId=${localStorage.getItem('eventId')}`,
  //   {headers: { "auth-token": localStorage.exhibitorToken }}
  //   )        
  //   .then(res => {
  //       if(res.data.errorCode === 0){
  //           //console.log(res.data.data)
  //           if(res.data.data.sponsors_type !== ''){
  //               setSponsorsTypes(res.data.data.sponsors_type.split('|'))
  //           }
  //       }
  //   })
  //   .catch(err => {
  //       console.log(err);
  //   });
  // }

  return (
    <Fragment>
      {pageLoader ? (
        <div className="loaderWrp">
          <div className="loaderInr">
            <img src={process.env.PUBLIC_URL + "/images/loader.gif"} alt="" />
          </div>
        </div>
      ) : null}
      <div className="p-3">
        <div className="card p-3 border-none box-shadow">
          <div className="pageHeading">
            <i
              className="fa fa-arrow-left backBtn"
              onClick={() => history.goBack()}
            ></i>
            <h4 className="text-center">
            Sponsor List
            </h4>
          </div>
        </div>        
        <div className="card p-3 border-none box-shadow">
          <section className="signleScreen overflow-hidden exhibitHallSec" style={{ minHeight:"1058px" }}>
          
          {logoLevelOrder.map((level) => {
  const sponsors = groupedSponsors(exhibitorsList)[level] || [];
  const { label } = logoLevelConfig[level] || {};

  if (sponsors.length === 0) return null;

  return (
    <div key={level}>
      <div className="card mb-3">
        <div className="card-body" style={{backgroundColor:"#0056b3"}}>
          <h5 className="card-title" style={{color:"#fff"}}>{label}</h5>
        </div>
      </div>
      <div className="exhibitHallBx">
        <div className="exhibitHallBxInr">
          <div className="sponSec">
            <div className="sponsersList">
              {sponsors.map((sponsor, index) => {
                return sponsor.logo ? (
                  sponsor.sponsor_link ? (
                    <a
                      key={sponsor.exhibitor_id}
                      href={sponsor.sponsor_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={sponsor.logo} alt="" />
                    </a>
                  ) : (
                    <a
                    key={sponsor.exhibitor_id}
                    href={sponsor.swebsite_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      key={sponsor.exhibitor_id}
                      src={sponsor.logo}
                      alt=""
                    />
                    </a>
                  )
                ) : null;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
})}

            {/* {sponsorsTypes.length > 0
                ?
                sponsorsTypes.map((sponsors,index) => (

                    <>
                        <div class="card mb-3">
                            <div class="card-body">
                                <h5 class="card-title">{sponsors}</h5>
                            </div>
                        </div>
                        <div className="exhibitHallBx">
                            <div className="exhibitHallBxInr">
                                <div className="sponSec">
                                <div className="sponsersList">
                                    {exhibitorsList
                                    .sort((a, b) => (a.company > b.company ? 1 : -1))
                                    .map((exhibitor) =>
                                        exhibitor.logo && index+1 == exhibitor.sponsors_type ? (                                             
                                        <Link
                                            to={`/mshc2025/attendee/exhibitor/${exhibitor.exhibitor_id}/Sponsor`}
                                            key={exhibitor.logo}
                                        >
                                            <img src={exhibitor.logo} alt={exhibitor.company} title={exhibitor.company} />
                                        </Link>
                                        ) : null
                                    )}
                                </div>
                                </div>
                            </div>
                        </div>
                    </>

                ))
                
                : */}
                {/* <div className="exhibitHallBx">
                    <div className="exhibitHallBxInr">
                        <div className="sponSec">
                        <div className="sponsersList">
                            {exhibitorsList
                            .map((sponsers) =>
                              sponsers.sponsor_link !== '' && sponsers.logo
                                          ?
                                          (
                                          <a href={sponsers.sponsor_link} target="_blank">
                                              <img src={sponsers.logo} alt=""/>
                                          </a>
                                          )
                                          :
                                          ''
                            )}
                        </div>
                        </div>
                    </div>
                </div> */}
            {/* } */}






            
          </section>
        </div>
      </div>
    </Fragment>
  );
};

export default ExhibitHall;
